<template>
  <div
    class="module-rules-block"
    :class="mainClasses"
    @click="modelValue = true"
  >
    <div class="module-rules-block__caption">
      <span>{{ title }}</span>
      <UISwitch
        v-if="!hideToggler"
        v-model="modelValue"
        :disabled
        :data-refid="`${camelCase(title)}RuleSwitcher`"
      />
    </div>
    <div
      v-if="(modelValue || hideToggler) && $slots.default"
      class="module-rules-block__content"
    >
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import { UISwitch } from '@ui/controllers'
import { camelCase } from 'lodash'

type Props = {
  title: string
  hideToggler?: boolean
  disabled?: boolean
}

defineProps<Props>()

const modelValue = defineModel<boolean>()

const mainClasses = computed(() => ({
  'module-rules-block--active': modelValue.value,
}))
</script>

<style>
.module-rules-block {
  @apply bg-gray-50 dark:bg-gray-700;
  @apply border border-gray-200 dark:border-gray-700;
  @apply rounded-md;

  &:not(.module-rules-block--active) {
    @apply cursor-pointer;
  }

  &--active {
    @apply min-h-24.5;
    @apply border-primary-selected;
  }

  &__caption,
  &__content {
    @apply py-3.5 px-4;
  }

  &__caption {
    @apply flex items-center justify-between;
    @apply text-sm;
  }

  &__content {
    @apply flex flex-col;
    @apply gap-2;
    @apply pt-0;
  }
}
</style>
